import React from "react";
import ButtonCell from "./../buttons/ButtonCell";
import EditRuleItemForm from "./EditRuleItemForm";
import { BonusSourceDetails } from "../../interfaces/BonusSourceDetails";

interface Props {
  itemBreakdown: BonusSourceDetails;
}

export default ({ itemBreakdown }: Props) => {
  const [started, setStarted] = React.useState(false);

  const onClickStartEdit = () => {
    setStarted(true);
  };
  const onClickCancelEdit = () => {
    setStarted(false);
  };

  const editButtonId = `edit-${itemBreakdown.actualBonus.sourceKey}`;

  return (
    <>
      <EditRuleItemForm
        open={started}
        formKey={itemBreakdown.actualBonus.sourceKey}
        key={itemBreakdown.actualBonus.sourceKey}
        bonusSourceDetails={itemBreakdown}
        onClickCancelEdit={onClickCancelEdit}
      />
      <ButtonCell
        key={editButtonId}
        dataTest={editButtonId}
        buttonText="Edit"
        classes={"cancel-edit"}
        onClick={onClickStartEdit}
      />
    </>
  );
};
